import { render } from "./ lawyerRequested.vue?vue&type=template&id=7cc174d0"
import script from "./ lawyerRequested.vue?vue&type=script&lang=js"
export * from "./ lawyerRequested.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__